import { c as _c } from "react/compiler-runtime";
import { IcoChevronRight16, IcoDotsHorizontal24 } from '@onefootprint/icons';
import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { Dropdown, useToast } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSheet from './language-sheet';
type FooterActionsProps = {
  config?: OnboardingSessionConfig;
  className?: string;
  defaultOpen?: boolean;
};
const handleRedirect = (url: string) => {
  window.open(url, '_blank');
};
const FooterActions = t0 => {
  const $ = _c(58);
  const {
    config,
    className,
    defaultOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "shell.global.components.footer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const {
    toast
  } = useToast();
  const hasSupportEmail = config?.supportEmail;
  const hasSupportPhone = config?.supportPhone;
  const hasSupportWebsite = config?.supportWebsite;
  const shouldShowSupportLinks = hasSupportEmail || hasSupportPhone || hasSupportWebsite;
  const [isLanguageSheetOpen, setIsLanguageSheetOpen] = useState(false);
  let t2;
  if ($[1] !== t || $[2] !== toast) {
    t2 = email => {
      if (email) {
        window.open(`mailto:${email}`, "_blank");
      } else {
        toast({
          title: t(_temp),
          description: t(_temp2)
        });
      }
    };
    $[1] = t;
    $[2] = toast;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const sendEmail = t2;
  let t3;
  if ($[4] !== t || $[5] !== toast) {
    t3 = phoneNumber => {
      if (phoneNumber) {
        navigator.clipboard.writeText(phoneNumber);
        toast({
          title: t(_temp3),
          description: t(_temp4)
        });
      } else {
        toast({
          title: t(_temp5),
          description: t(_temp6)
        });
      }
    };
    $[4] = t;
    $[5] = toast;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const copyToClipboard = t3;
  let t4;
  if ($[7] !== t || $[8] !== toast) {
    t4 = link => {
      if (link) {
        window.open(link, "_blank");
      } else {
        toast({
          title: t(_temp7),
          description: t(_temp8)
        });
      }
    };
    $[7] = t;
    $[8] = toast;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const openLink = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Dropdown.Trigger><IcoDotsHorizontal24 color="primary" /></Dropdown.Trigger>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== config?.privacyPolicyUrl) {
    t6 = () => handleRedirect(config?.privacyPolicyUrl ?? "https://onefootprint.com/privacy-policy");
    $[11] = config?.privacyPolicyUrl;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp9);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Dropdown.Item onClick={t6} size="compact">{t7}</Dropdown.Item>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== config?.termsOfServiceUrl) {
    t9 = () => handleRedirect(config?.termsOfServiceUrl ?? "https://onefootprint.com/terms-of-service");
    $[18] = config?.termsOfServiceUrl;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t(_temp10);
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = <Dropdown.Item onClick={t9} size="compact">{t10}</Dropdown.Item>;
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t8) {
    t12 = <Dropdown.Group>{t8}{t11}</Dropdown.Group>;
    $[25] = t11;
    $[26] = t8;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Dropdown.Divider />;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== config?.supportEmail || $[30] !== config?.supportPhone || $[31] !== config?.supportWebsite || $[32] !== copyToClipboard || $[33] !== hasSupportEmail || $[34] !== hasSupportPhone || $[35] !== hasSupportWebsite || $[36] !== openLink || $[37] !== sendEmail || $[38] !== shouldShowSupportLinks || $[39] !== t) {
    t14 = shouldShowSupportLinks && <><Dropdown.Group>{hasSupportEmail && <Dropdown.Item onClick={() => sendEmail(config?.supportEmail)} size="compact">{t(_temp11)}</Dropdown.Item>}{hasSupportPhone && <Dropdown.Item onClick={() => copyToClipboard(config?.supportPhone)} size="compact">{t(_temp12)}</Dropdown.Item>}{hasSupportWebsite && <Dropdown.Item onClick={() => openLink(config?.supportWebsite)} size="compact">{t(_temp13)}</Dropdown.Item>}</Dropdown.Group><Dropdown.Divider /></>;
    $[29] = config?.supportEmail;
    $[30] = config?.supportPhone;
    $[31] = config?.supportWebsite;
    $[32] = copyToClipboard;
    $[33] = hasSupportEmail;
    $[34] = hasSupportPhone;
    $[35] = hasSupportWebsite;
    $[36] = openLink;
    $[37] = sendEmail;
    $[38] = shouldShowSupportLinks;
    $[39] = t;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  let t15;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => {
      setIsLanguageSheetOpen(true);
    };
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t) {
    t16 = t(_temp14);
    $[42] = t;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== t16) {
    t17 = <Dropdown.Group><Dropdown.Item iconRight={IcoChevronRight16} onSelect={t15} size="compact">{t16}</Dropdown.Item></Dropdown.Group>;
    $[44] = t16;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== className || $[47] !== t12 || $[48] !== t14 || $[49] !== t17) {
    t18 = <Dropdown.Portal><Dropdown.Content align="end" className={className}>{t12}{t13}{t14}{t17}</Dropdown.Content></Dropdown.Portal>;
    $[46] = className;
    $[47] = t12;
    $[48] = t14;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => {
      setIsLanguageSheetOpen(false);
    };
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== isLanguageSheetOpen) {
    t20 = <LanguageSheet open={isLanguageSheetOpen} onClose={t19} />;
    $[52] = isLanguageSheetOpen;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== defaultOpen || $[55] !== t18 || $[56] !== t20) {
    t21 = <Dropdown.Root defaultOpen={defaultOpen}>{t5}{t18}{t20}</Dropdown.Root>;
    $[54] = defaultOpen;
    $[55] = t18;
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  return t21;
};
export default FooterActions;
function _temp($) {
  return $.support.email["toast-error"].title;
}
function _temp2($_0) {
  return $_0.support.email["toast-error"].description;
}
function _temp3($_1) {
  return $_1.support.phone["toast-success"].title;
}
function _temp4($_2) {
  return $_2.support.phone["toast-success"].description;
}
function _temp5($_3) {
  return $_3.support.phone["toast-error"].title;
}
function _temp6($_4) {
  return $_4.support.phone["toast-error"].description;
}
function _temp7($_5) {
  return $_5.support.website["toast-error"].title;
}
function _temp8($_6) {
  return $_6.support.website["toast-error"].description;
}
function _temp9($_7) {
  return $_7.privacy;
}
function _temp10($_8) {
  return $_8.terms;
}
function _temp11($_9) {
  return $_9.support.email.label;
}
function _temp12($_10) {
  return $_10.support.phone.label;
}
function _temp13($_11) {
  return $_11.support.website.label;
}
function _temp14($_12) {
  return $_12["change-language"];
}